import { GatsbyImageProps } from "gatsby-plugin-image";
import React from "react";
import styled from "styled-components";
import { Column, Frame, ImgBox } from "./styles";

export interface Props {
	children?: React.ReactNode;
	className?: string;
	reverse?: boolean;
	img?:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
}
const ArticleImageColumn: React.FC<Props> = (props) => {
	const { children, className, reverse, img } = props;
	return (
		<Frame className={className} reverse={reverse}>
			{children && <Column>{children}</Column>}
			{img && <ImgBox>{img}</ImgBox>}
		</Frame>
	);
};

export default styled(ArticleImageColumn)``;
